"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookSpec = exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../openapi");
const guard_1 = require("../guard");
const shared_1 = require("../shared");
const Registry = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.Registry.Spec';
const DevicePageResponse = openapi_1.Response.Success(Registry.DevicePage).annotations({
    description: 'Paginated legacy device registry records',
});
const DeviceResponse = openapi_1.Response.Success(Registry.Device).annotations({
    description: 'Legacy device registry record',
});
const FilterListResponse = openapi_1.Response.Success(Registry.FilterList).annotations({
    description: 'Stored device-search filters',
});
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful device mutation',
});
/*
 * 422 without `inputValidation`. include without scopeToCaller answers a fixed
 * reason; a rejected search filter answers with the thrown message.
 */
const LegacyReasonValidation = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.LegacyReasonValidation`, 'INVALID_REQUEST', 'Validation Error (Legacy Reason Format)', 'include without scopeToCaller, or a search filter the registry rejected. Carries no express-validator field errors.', { reason: effect_1.Schema.String });
const InvalidSerialNumber = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidSerialNumber`, 'INVALID_SERIAL_NUMBER', 'Invalid Serial Number', 'The serial number does not encode a known model. Carries no express-validator field errors.');
const InvalidModel = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidModel`, 'INVALID_MODEL', 'Invalid Model', 'The supplied model does not match the model encoded in the serial number. Carries no express-validator field errors.');
/*
 * 400 that is not the decode error. buildBadRequestResponse spreads `error`
 * and `endpoint` over the BAD_REQUEST envelope. Create and update use
 * different deprecation text.
 */
const V2RegistrationRejected = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('BAD_REQUEST'),
        error: effect_1.Schema.Literal('Registering a v2 device through API v1 is deprecated. Please use v2 version.'),
        endpoint: effect_1.Schema.Literal('/v2/admin/device/registry'),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.V2RegistrationRejected`,
    title: 'V2 Registration Rejected',
    description: 'The serial number is a v2 device id. Create answers this in addition to the decode 400.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 400,
});
const V2ManagementRejected = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('BAD_REQUEST'),
        error: effect_1.Schema.Literal('Managing a v2 device through API v1 is deprecated. Please use v2 version.'),
        endpoint: effect_1.Schema.Literal('/v2/admin/device/registry'),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.V2ManagementRejected`,
    title: 'V2 Management Rejected',
    description: 'The serial number resolves to a v2 model. Replace, patch and the three Svix customer-assignment webhooks answer this in addition to the decode 400.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 400,
});
// Query structs intentionally have no identifier (see shared.ts).
// Only the spelled-out words, because the handlers compare against those exact strings:
// scoping is on for `scopeToCaller === 'true'` and the contact copy is off for
// `legacyContactCompat === 'false'`. Documenting `1` and `0` here would promise a client
// that `scopeToCaller=1` scopes the query, when it silently answers the whole fleet.
// `includeShared` below keeps the wider set; its handler does accept `1`.
const BooleanString = effect_1.Schema.Literal('true', 'false');
const include = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
    description: 'Comma-separated properties, metaData and/or accountNumber; requires scopeToCaller except for SAT registry reads',
});
const scopeToCaller = effect_1.Schema.optionalWith(BooleanString, { exact: true }).annotations({
    description: 'Opt in to role-based fleet scoping; legacy default is unscoped',
});
const legacyContactCompat = effect_1.Schema.optionalWith(BooleanString, { exact: true }).annotations({
    description: 'Set false to stop copying contactInfo fields onto installationAddress',
});
const pagination = {
    page: shared_1.page,
    pageSize: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }),
    size: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }).annotations({
        description: 'Validated but not used as page size on these routes',
    }),
    orderBy: shared_1.orderBy,
    orderDir: shared_1.orderDir,
};
const ListQuery = effect_1.Schema.Struct({
    ...pagination,
    include,
    scopeToCaller,
    legacyContactCompat,
});
const SearchQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    name: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    model: effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Array(effect_1.Schema.String)), { exact: true }).annotations({
        description: 'One model or repeated query parameter',
    }),
    ownerId: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    dealerId: effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Array(effect_1.Schema.String)), { exact: true }).annotations({
        description: 'One dealer id or repeated query parameter',
    }),
    tenantId: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2)), { exact: true }),
    registered: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false'), { exact: true }),
    online: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false'), { exact: true }),
    region: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(2), effect_1.Schema.maxLength(5)), { exact: true }),
    countryCode: effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Array(effect_1.Schema.String)), {
        exact: true,
    }).annotations({
        description: 'One code or repeated query parameter; every code has length 3',
    }),
    installationAddress: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.minLength(3)), { exact: true }),
    filterId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Takes precedence over filterParams and inline search fields',
    }),
    filterParams: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'JSON-encoded SearchFilterParams; takes precedence over inline search fields',
    }),
    ...pagination,
    limit: effect_1.Schema.optionalWith(shared_1.PositiveIntFromString, { exact: true }).annotations({
        description: 'Alias of pageSize on search only; default page size is 1000',
    }),
    include,
    scopeToCaller,
    legacyContactCompat,
});
const RegistryQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.NonEmptyString,
    include,
    scopeToCaller,
    legacyContactCompat,
});
const FilterListQuery = effect_1.Schema.Struct({
    includeShared: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false', '1', '0'), { exact: true }),
});
const listRegistry = platform_1.HttpApiEndpoint.get('listRegistry') `/registry/list`
    .setUrlParams(ListQuery)
    .addSuccess(DevicePageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(LegacyReasonValidation)
    .annotate(platform_1.OpenApi.Title, 'List Devices')
    .annotate(platform_1.OpenApi.Description, 'Lists the legacy device fleet. Without scopeToCaller the query is the whole fleet; scopeToCaller=true applies role scope. Default page size is 50.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const searchRegistry = platform_1.HttpApiEndpoint.get('searchRegistry') `/registry/search`
    .setUrlParams(SearchQuery)
    .addSuccess(DevicePageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(LegacyReasonValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Search Devices')
    .annotate(platform_1.OpenApi.Description, 'Searches registry records. filterId wins over filterParams, which wins over inline fields. Stored filter lookup does not check ownership. Without scopeToCaller the query is the whole fleet; scopeToCaller=true applies role scope. Default page size is 1000.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const searchRegistryWithBody = platform_1.HttpApiEndpoint.post('searchRegistryWithBody') `/registry/search`
    .setUrlParams(SearchQuery)
    .setPayload(Registry.RegistrySearchPayload)
    .addSuccess(DevicePageResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(LegacyReasonValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Search Devices with JSON Filters')
    .annotate(platform_1.OpenApi.Description, 'Same search as GET. The router merges query then JSON body, so body fields win on collisions.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getRegistry = platform_1.HttpApiEndpoint.get('getRegistry') `/registry`
    .setUrlParams(RegistryQuery)
    .addSuccess(DeviceResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(LegacyReasonValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Device')
    .annotate(platform_1.OpenApi.Description, 'Returns one legacy registry record. Authentication is read RBAC (Bearer/CPort) OR ?sat=; SAT access is additionally restricted to its named device.')
    .pipe(guard_1.withReadGuard)
    .middleware(openapi_1.Security.V1FleetSat)
    .pipe(openapi_1.Error.withV1StandardErrors);
const createRegistry = platform_1.HttpApiEndpoint.post('createRegistry') `/registry`
    .setPayload(Registry.RegistryCreatePayload)
    .addSuccess(EmptySuccessResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(V2RegistrationRejected)
    .addError(InvalidSerialNumber)
    .addError(InvalidModel)
    .annotate(platform_1.OpenApi.Title, 'Create Device')
    .annotate(platform_1.OpenApi.Description, 'Creates a legacy v1 registry record. A v2 serial is a second 400, BAD_REQUEST, carrying the deprecation text and endpoint /v2/admin/device/registry. A serial that encodes no model is 422 INVALID_SERIAL_NUMBER, and a mismatched model is 422 INVALID_MODEL; neither carries inputValidation. Returns empty data, not the created device.')
    .pipe(guard_1.withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const replaceRegistry = platform_1.HttpApiEndpoint.put('replaceRegistry') `/registry`
    .setPayload(Registry.RegistryUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(V2ManagementRejected)
    .annotate(platform_1.OpenApi.Title, 'Replace Device')
    .annotate(platform_1.OpenApi.Description, 'Replaces registry fields. An omitted dealerId, accountNumber, manufacturingSerialNumber, or sku is cleared, and assetTag is always cleared. Omitted name, ownerId and tenantId are kept. A resolved v2 serial is a second 400, BAD_REQUEST, carrying the managing-deprecation text and endpoint /v2/admin/device/registry. An unknown serial is 500: the lookup does not throw, so the 404 branch never runs.')
    .pipe(guard_1.withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const patchRegistry = platform_1.HttpApiEndpoint.patch('patchRegistry') `/registry`
    .setPayload(Registry.RegistryUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(V2ManagementRejected)
    .annotate(platform_1.OpenApi.Title, 'Patch Device')
    .annotate(platform_1.OpenApi.Description, 'Updates supplied scalar fields and leaves other omitted scalars in place. Every call rewrites installationAddress and providedLocation: omitted address fields are stored as null, and providedLocation is replaced. contactInfo is written only when a non-empty contact field is sent, and omitted contact fields are stored as null. A resolved v2 serial is a second 400, BAD_REQUEST, carrying the managing-deprecation text and endpoint /v2/admin/device/registry. An unknown serial is 500: the lookup does not throw, so the 404 branch never runs.')
    .pipe(guard_1.withTechnicalGuard, openapi_1.Error.withV1StandardErrors);
const deleteRegistry = platform_1.HttpApiEndpoint.del('deleteRegistry') `/registry`
    .setPayload(Registry.DeviceIdentity)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Deregister Device')
    .annotate(platform_1.OpenApi.Description, 'Deregisters a device. This is not the full fleet teardown provided by DELETE /admin/device. An unknown serial is 500. The CPort edit check compares the session class with CPortSessionManager, which never matches, so it does not return 401.')
    .pipe(guard_1.withDeviceDeletionGuard, openapi_1.Error.withV1StandardErrors);
const listFilters = platform_1.HttpApiEndpoint.get('listFilters') `/registry/filter/list`
    .setUrlParams(FilterListQuery)
    .addSuccess(FilterListResponse)
    .annotate(platform_1.OpenApi.Title, 'List Device Search Filters')
    .annotate(platform_1.OpenApi.Description, 'Lists the caller’s filters; includeShared=true also returns filters whose ACL is shared.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const createFilter = platform_1.HttpApiEndpoint.post('createFilter') `/registry/filter`
    .setPayload(Registry.FilterCreatePayload)
    .addSuccess(EmptySuccessResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Device Search Filter')
    .annotate(platform_1.OpenApi.Description, 'Creates a private or shared filter. ACL defaults to private. The generated filter id is not returned.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const updateFilter = platform_1.HttpApiEndpoint.put('updateFilter') `/registry/filter`
    .setPayload(Registry.FilterUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update Device Search Filter')
    .annotate(platform_1.OpenApi.Description, 'Replaces a filter owned by the current user.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const deleteFilter = platform_1.HttpApiEndpoint.del('deleteFilter') `/registry/filter`
    .setPayload(Registry.FilterDeletePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Device Search Filter')
    .annotate(platform_1.OpenApi.Description, 'Deletes a filter owned by the current user. Runtime also accepts id in query because router merges query and body.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const deleteFleetDevice = platform_1.HttpApiEndpoint.del('deleteFleetDevice') ``
    .setPayload(Registry.DeviceIdentity)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1Conflict)
    .annotate(platform_1.OpenApi.Title, 'Delete Device from Fleet')
    .annotate(platform_1.OpenApi.Description, 'Permanently removes an unowned device and its historical/configuration data. Returns 409 DEVICE_REGISTERED while ownerId is set. Distinct from registry deregistration.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const assignRegistryWebhook = platform_1.HttpApiEndpoint.post('assignRegistryWebhook') `/registry`
    .setPayload(Registry.RegistryUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(V2ManagementRejected)
    .annotate(platform_1.OpenApi.Title, 'Assign Device Customer (Svix webhook)')
    .annotate(platform_1.OpenApi.Description, 'Updates an existing registry record with PATCH semantics and never creates a device. Omitted scalars are preserved. Every call rewrites installationAddress and providedLocation: omitted address fields are stored as null, and providedLocation is replaced. contactInfo is written only when a non-empty contact field is sent, and omitted contact fields are stored as null. On success emits device.customer.assignment.acknowledged; acknowledgement failure is ignored. An unknown serial returns 500.')
    .pipe(openapi_1.Security.V1SvixWebhook, openapi_1.Error.withV1PublicErrors);
const replaceRegistryWebhook = platform_1.HttpApiEndpoint.put('replaceRegistryWebhook') `/registry`
    .setPayload(Registry.RegistryUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(V2ManagementRejected)
    .annotate(platform_1.OpenApi.Title, 'Replace Device Customer Assignment (Svix webhook)')
    .annotate(platform_1.OpenApi.Description, 'Updates an existing registry record with replace semantics. An omitted dealerId, accountNumber, manufacturingSerialNumber, or sku is cleared, and assetTag is always cleared. Omitted name, ownerId and tenantId are kept. Every call rewrites installationAddress and providedLocation: omitted address fields are stored as null, and providedLocation is replaced. contactInfo is always written, and omitted contact fields are stored as null. On success emits device.customer.assignment.acknowledged; acknowledgement failure is ignored. An unknown serial returns 500.')
    .pipe(openapi_1.Security.V1SvixWebhook, openapi_1.Error.withV1PublicErrors);
const patchRegistryWebhook = platform_1.HttpApiEndpoint.patch('patchRegistryWebhook') `/registry`
    .setPayload(Registry.RegistryUpdatePayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(V2ManagementRejected)
    .annotate(platform_1.OpenApi.Title, 'Update Device Customer Assignment (Svix webhook)')
    .annotate(platform_1.OpenApi.Description, 'Same update behavior as POST: omitted scalars are preserved. Every call rewrites installationAddress and providedLocation: omitted address fields are stored as null, and providedLocation is replaced. contactInfo is written only when a non-empty contact field is sent, and omitted contact fields are stored as null. On success emits device.customer.assignment.acknowledged; acknowledgement failure is ignored. An unknown serial returns 500.')
    .pipe(openapi_1.Security.V1SvixWebhook, openapi_1.Error.withV1PublicErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.device.registry')
    .add(listRegistry)
    .add(searchRegistry)
    .add(searchRegistryWithBody)
    .add(getRegistry)
    .add(createRegistry)
    .add(replaceRegistry)
    .add(patchRegistry)
    .add(deleteRegistry)
    .add(listFilters)
    .add(createFilter)
    .add(updateFilter)
    .add(deleteFilter)
    .add(deleteFleetDevice)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Device Registry')
    .annotate(platform_1.OpenApi.Description, 'Admin device registry, search filters and fleet deletion')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
exports.WebhookSpec = platform_1.HttpApiGroup.make('v1.webhook.svix.device.registry')
    .add(assignRegistryWebhook)
    .add(replaceRegistryWebhook)
    .add(patchRegistryWebhook)
    .prefix('/webhook/svix/device')
    .annotate(platform_1.OpenApi.Title, 'Device Registry Webhook')
    .annotate(platform_1.OpenApi.Description, 'Svix customer-assignment webhook that writes the device registry')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map